import { forwardRef } from 'react';
import { Trans } from 'react-i18next';
import { cn } from '@/lib/utils';

interface Props extends React.ButtonHTMLAttributes<HTMLHeadingElement> {
  i18nKey: string;
}

const Title = forwardRef<HTMLHeadingElement, Props>(
  ({ i18nKey, className, ...props }, ref) => {
    return (
      <h1
        ref={ref}
        className={cn(
          'whitespace-pre-wrap pb-6 text-3xl font-bold text-white',
          className
        )}
        {...props}
      >
        <Trans
          i18nKey={i18nKey}
          components={{
            b: (
              <span className="text-secondary">
                <strong />
              </span>
            ),
          }}
        />
      </h1>
    );
  }
);
Title.displayName = 'Title';
export default Title;
